var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LateralElement',{attrs:{"item":_vm.fichas,"drawer":_vm.drawer}})}
var staticRenderFns = []

export { render, staticRenderFns }